import { Fragment, useState } from 'react';

import { DefaultWidgetNames } from '@/api/rest/resources/types/widget';
import { ExpandedRecommendationCard } from '@/components/widgets/o/RecommendationCard/ExpandedRecommendationCard';
import { RecommendationCard } from '@/components/widgets/o/RecommendationCard/types';
import { SidebarItem } from '@/components/widgets/o/Sidebar/Sidebar';
import { WidgetSlotRenderer } from '@/components/widgets/WidgetSlotRenderer';
import { useRecommendations } from '@/hooks/useRecommendations';

import { CoPilotContextProvider } from '../CoPilotContextProvider';
import { useFilterRecommendationsBySite } from '../hooks/useFilterRecommendationsBySite';
import { parseRecommendation } from '../utils/parseRecommendation';
import { CoPilotEmptyContent, CoPilotHeader, CoPilotProps } from './CoPilot';

export const Recommendations = (props: CoPilotProps) => {
  const [selectedRecommendationCard, setSelectedRecommendationCard] = useState<RecommendationCard | null>(null);

  const recommendations = useRecommendations().data?.recommendations ?? [];
  const filteredRecommendations = useFilterRecommendationsBySite(recommendations);

  const recommendationsAsWidgets = filteredRecommendations.map((recommendation) => ({
    name: DefaultWidgetNames.default_recommendation_card,
    type: recommendation.recommendation_data.type,
    relatedData: parseRecommendation(recommendation),
    visible: true,
  }));

  const coPilotItems: SidebarItem[] = recommendationsAsWidgets.map((card, index) => ({
    key: card?.relatedData?.id ?? `copilot-card-${index}`,
    content: <WidgetSlotRenderer nestedWidget={card} />,
  }));

  const isSelectedRecommendationCardAvailableInPage =
    selectedRecommendationCard && filteredRecommendations.find((rec) => rec.id === selectedRecommendationCard.id);

  const coPilotView = isSelectedRecommendationCardAvailableInPage
    ? [{ content: <ExpandedRecommendationCard recommendationCard={selectedRecommendationCard} /> }]
    : coPilotItems;

  return coPilotView.length > 0 ? (
    <CoPilotContextProvider value={{ selectedRecommendationCard, setSelectedRecommendationCard }}>
      <CoPilotHeader {...props} />
      {!props.isCollapsed &&
        coPilotView.map((item, index) => <Fragment key={`co-pilot-item-${index}`}>{item.content}</Fragment>)}
    </CoPilotContextProvider>
  ) : (
    <CoPilotEmptyContent {...props} />
  );
};
